import dateFnsFormat from "date-fns/format";
import { convertToLocalTime } from "date-fns-timezone";
import localizedStrings from "./localize";

export function isObjectEmpty(inputObject) {
  if (inputObject !== undefined) {
    // console.log(inputObject,"inputObject")
    return Object.keys(inputObject).length === 0;
  }
  return true;
}

export function dateFormatter(data) {
  var date = new Date(data);
  return (
    (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
    "/" +
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
    "/" +
    date.getFullYear()
  );
}

export function dateValueFormatter(data) {
  var date = new Date(data);
  return (
    date.getFullYear() +
    "-" +
    (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
    "-" +
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate())
  );
}

export function isValidPathUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
}

export function classStatusOptionList(value) {
  let optionSetClassStatus;
  if (value === "Available")
    optionSetClassStatus = localizedStrings.general.classStatusAvailable;
  if (value === "Full")
    optionSetClassStatus = localizedStrings.general.classStatusFull;
  if (value === "Wait List")
    optionSetClassStatus = localizedStrings.general.classStatusWaitList;
  if (value === "Cancelled")
    optionSetClassStatus = localizedStrings.general.classStatusCancelled;
  if (value === "Closed")
    optionSetClassStatus = localizedStrings.general.classStatusClosed;
  if (value === "Completed")
    optionSetClassStatus = localizedStrings.general.classStatusCompleted;
  return optionSetClassStatus;
}

export function statusOptionList(value) {
  let optionSetStatus;
  if (value === "Wait list")
    optionSetStatus = localizedStrings.general.StatusWaitList;
  if (value === "Enrolled")
    optionSetStatus = localizedStrings.general.StatusEnrolled;
  if (value === "Completed")
    optionSetStatus = localizedStrings.general.StatusCompleted;
  if (value === "Cancelled")
    optionSetStatus = localizedStrings.general.StatusCancelled;
  if (value === "Incomplete")
    optionSetStatus = localizedStrings.general.StatusIncomplete;
  if (value === "Dropped")
    optionSetStatus = localizedStrings.general.StatusDropped;
  if (value === "Tentative")
    optionSetStatus = localizedStrings.general.StatusTentative;
  if (value === "Transfer")
    optionSetStatus = localizedStrings.general.StatusTransfer;
  if (value === "Required to Withdraw")
    optionSetStatus = localizedStrings.general.StatusWithdraw;
  if (value === "Withdrawal")
    optionSetStatus = localizedStrings.general.StatusWithdrawal;
  return optionSetStatus;
}
export function paymentOptionList(value, pdf = false) {
  let optionSetPayment;
  if (value === "Cash") optionSetPayment = localizedStrings.general.paymentCash;
  if (value === "Check")
    optionSetPayment = localizedStrings.general.paymentCheck;
  if (value === "Credit")
    optionSetPayment = localizedStrings.general.paymentCredit;
  if (value === "Debit")
    optionSetPayment = localizedStrings.general.paymentDebit;
  if (value === "Online")
    optionSetPayment = localizedStrings.general.paymentOnline;
  if (value === "GlobalPay")
    optionSetPayment = localizedStrings.general.paymentGlobalPay;
  if (value === "Wire") optionSetPayment = localizedStrings.general.paymentWire;
  if (value === "Award")
    optionSetPayment = localizedStrings.general.paymentAward;
  if (value === "Electronic refund")
    optionSetPayment = localizedStrings.general.paymentElectronicrefund;
  if (value === "Refund by bank transfer")
    optionSetPayment = localizedStrings.general.paymentRefundbybanktransfer;
  if (
    pdf === false &&
    (value === "RF-EFT" || value === "RF-WIRE" || value === "RF-CC")
  )
    optionSetPayment = localizedStrings.general.reimbursement;
  if (pdf === true && value === "RF-EFT")
    optionSetPayment = localizedStrings.general.reimbursementeft;
  if (pdf === true && value === "RF-WIRE")
    optionSetPayment = localizedStrings.general.reimbursementwire;
  if (pdf === true && value === "RF-CC")
    optionSetPayment = localizedStrings.general.reimbursementcc;
  return optionSetPayment;
}

export function profileOptionList(value) {
  let optionSetProfile;
  if (value === "Male") optionSetProfile = localizedStrings.general.profileMale;
  if (value === "Female")
    optionSetProfile = localizedStrings.general.profileFemale;
  if (value === "Not Specified")
    optionSetProfile = localizedStrings.general.profileNotSpecified;
  if (value === "Undisclosed")
    optionSetProfile = localizedStrings.general.profileUndisclosed;
  if (value === "Non-binary")
    optionSetProfile = localizedStrings.general.profileNonbinary;
  if (value === "Agender")
    optionSetProfile = localizedStrings.general.profileAgender;
  if (value === "Bigender") optionSetProfile = "Bigender";
  if (value === "Genderfluid") optionSetProfile = "Genderfluid";
  if (value === "Genderqueer") optionSetProfile = "Genderqueer";
  if (value === "Polygender") optionSetProfile = "Polygender";
  if (value === "I prefer not to answer")
    optionSetProfile = "I prefer not to answer";

  return optionSetProfile;
}

export function selectClassOptionList(value) {
  let optionSetSelectClass;
  if (value === "Grade")
    optionSetSelectClass = localizedStrings.general.selectClassGrade;
  if (value === "Pass/Fail")
    optionSetSelectClass = localizedStrings.general.selectClassPassFail;
  if (value === "Audit")
    optionSetSelectClass = localizedStrings.general.selectClassAudit;
  if (value === "Award")
    optionSetSelectClass = localizedStrings.general.selectClassAward;
  return optionSetSelectClass;
}

export function applicationStatusOptionList(value) {
  let optionSetApplicationStatus;
  if (value === "Started")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.started;
  if (value === "Submitted")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.submitted;
  if (value === "Action Required")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.actionrequired;
  if (value === "Ongoing Evaluation")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.ongoingevaluation;
  if (value === "Conditional Offer")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.conditionaloffer;
  if (value === "Official Acceptance")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.officialacceptance;
  if (value === "Rejected")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.rejected;
  if (value === "Inactive")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.inactive;
  if (value === "Offer Accepted")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.offeraccepted;
  if (value === "Matriculant")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.matriculant;
  if (value === "Student")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.student;
  if (value === "Cancelled")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.cancelled;
  if (value === "Waitlisted")
    optionSetApplicationStatus =
      localizedStrings.application.statusOptions.waitlisted;
  return optionSetApplicationStatus;
}

export function getYear() {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 26 }, (_, i) => {
    const year = currentYear - i;
    return {
      value: year,
      displayValue: year.toString(),
    };
  });
}

export function getStartYearRange() {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 61 }, (_, i) => {
    const year = currentYear - i;
    return {
      value: year,
      displayValue: year.toString(),
    };
  });
}

export function getEndYearRange() {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 60; // 60 years in the past
  const endYear = currentYear + 2; // 2 years in the future

  return Array.from({ length: endYear - startYear + 1 }, (_, i) => {
    const year = endYear - i; // Start from endYear and decrement
    return {
      value: year,
      displayValue: year.toString(),
    };
  });
}

export const DEFAULT_DATE_FORMAT = "yyyy-MM-dd";

/**
 * Format a date to a string
 *
 * @param date
 */
export const formatDate = (date) => {
  // Check for invalid date
  const parsedDate = new Date(date);
  if (isNaN(parsedDate)) {
    return "Invalid Date";
  }

  // Get the timezone from browser using native methods
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Convert to local date in the specified timezone
  const localDate = convertToLocalTime(parsedDate, { timeZone: timezone });

  // Format the local date
  return dateFnsFormat(localDate, DEFAULT_DATE_FORMAT);
};

export const formatDateTime = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
